import React from 'react'

const formatStringRenderToJsxElement = (value = '', config = []) => {
  // 防止script注入攻击
  let result = value.replace(/<script[^>]*>[^<]*<\/script\s*>/gi,'')

  config.length > 0 && config?.forEach((item) => {
    result = result.replace(RegExp(item.reg, 'gi'), item.replaceValue)
  })

  return <div className="consult-detail"
      dangerouslySetInnerHTML={{ __html: result }}></div>
}

export default formatStringRenderToJsxElement